import { axiosInstanceMain } from '../../../utils/axiosGlobalUtils'
import { ITenant, galeriasResponseType } from '../types'

export const getGalerias = (tenant: ITenant, deviceId: string, clave: string) =>
  axiosInstanceMain.get(`/${tenant.path}/galerias?deviceId=${deviceId}&clave=${clave}`).then((result) => {
    const response: galeriasResponseType = {
      errorCode: result.data?.errorCode,
      errorMessage: result.data?.errorMessage,
      message: result.data?.message,
      data: result.data?.data || []
    }
    return response
  })
